import React, { memo } from "react";
import IntroTest from "components/Question/Speaking/IntroTest.jsx";

const SelfIntro = memo( function SelfIntro({
	user, totalQuestions, time , nextButton
}) {

	return <>
	<IntroTest nextButton={nextButton} />
	</>
});

export default SelfIntro;